import React from "react";
import PersonalInformationForm from "./PersonalInformationForm";

const PersonalInformation = ({ personalInformation, handleChange }) => {
  return (
    <div className="formgrid grid">
      <div className="field">
        <p className="heading">Personal Information</p>
        <p className="description">
          Basic identity and contact details to uniquely identify and reach the
          employee.
        </p>
      </div>
      <PersonalInformationForm
        personalInformation={personalInformation}
        handleChange={handleChange}
        isLoading={false}
        isEdit={true}
      />
    </div>
  );
};

export default PersonalInformation;
